export default __webpack_public_path__ + "static/media/Standard32.71a57f34.png";